/* eslint-disable no-unused-vars */
import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import cn from 'classnames'
import uuid from 'util/uuid'
import debug from 'util/debug'
import SVGIcon from '../SVGIcon'
import styles from './styles.less'

/**
 * A simple colored checkbox
 */
class CheckboxV2 extends PureComponent {
  static propTypes = {
    /** Whether or not checkbox is checked. */
    checked: PropTypes.bool,

    /** Additional classes. */
    className: PropTypes.string,

    /** A unique identifier. */
    id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),

    /** The text of the associated label element. */
    label: PropTypes.string,

    /** The HTML input name. */
    name: PropTypes.string,

    /**
     * Called when the checkbox is clicked.
     *
     * @param {SyntheticEvent} event - React's original SyntheticEvent.
     * @param {object} data - All props and current checked state.
     */
    onClick: PropTypes.func,

    /** The HTML input value. */
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),

    /** Size of the checkbox */
    size: PropTypes.number,

    /** Disable the input */
    disabled: PropTypes.bool,
  }

  static defaultProps = {
    checked: false,
    className: undefined,
    id: undefined,
    label: undefined,
    name: undefined,
    onClick: undefined,
    value: undefined,
    size: 16,
    disabled: false,
  }

  constructor(props) {
    super(props)
    this.state = {
      checked: props.checked,
      fallbackId: uuid(),
    }
  }

  handleOnClick = e => {
    debug('handleOnClick()')
    const { onClick, disabled } = this.props
    const { checked } = this.state
    if (disabled) return
    if (onClick) onClick(e, { ...this.props, checked: !checked })
    this.setState({ checked: !checked })
  }

  render() {
    const {
      className,
      id,
      label,
      name,
      value,
      indeterminate,
      disabled,
      size,
    } = this.props
    const { checked, fallbackId } = this.state

    // the <span> (not the label) is where we attach the pseudo classes to render
    // the styled checkbox. Its also where we attach the onCheckboxClick handler
    return (
      <label
        htmlFor={id || fallbackId}
        // class="c-custom-checkbox"
        className={cn(className, styles['checkbox-v2'], 'checkbox-v2', {
          indeterminate: indeterminate && !disabled,
          disabled,
        })}
      >
        <input
          id={id || fallbackId}
          checked={checked}
          name={name}
          type="checkbox"
          value={value}
          disabled={disabled}
          style={{
            width: size,
            height: size,
          }}
          onClick={this.handleOnClick}
        />
        <SVGIcon
          color="color.monochrome.black"
          name={indeterminate ? 'minus' : 'check'}
          size={size}
          aria-hidden="true"
          focusable="false"
          defaultFill="none"
        />
        {label}
      </label>
    )
  }
}

export default CheckboxV2
